import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import LandingPageHeader from '../Layouts/LandingPageHeader';
import { getCategories } from '../Services/Utils/ServiceProviderApis';
import { notifySet } from '../Services/Actions/CommonActions';
import { getImage } from '../Services/Utils/FileApis';

function Explore() {
  const dispatch = useDispatch();
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    sideBarCategories();
  }, []);

  const sideBarCategories = async () => {
    const params = {
      start: 0,
      recordSize: ''
    };
    await getCategories({ active: true, explore: true }, params).then((responseJson) => {
      const { list, status } = responseJson;
      if (status === true) {
        setCategoryData(list);
      } else {
        dispatch(notifySet({ type: 'error', message: 'Category list not found' }));
      }
    });
  };

  return (
    <div id="fullpage" className="fullpage-wrapper">
      <LandingPageHeader
        class="sticky"
        header="SERVICE PARTNERS"
      />
      <div className="explore-container">
        {categoryData.map((category, key) => (
          <div className="container" key={key}>
            <div className="row">
              {category.serviceProviderViews.length === 0 ? (
                ''
              ) : (
                <div className="col-md-12">
                  <h5 className="img_headtitle">{category.name}</h5>
                </div>
              )}
              {category.serviceProviderViews.length > 0 && (
                <div className="col-md-12">
                  <div className="img_logos">
                    <ul>
                      {category.serviceProviderViews?.map((serviceImage, Categorykey) => (
                        <li key={Categorykey}>
                          <img
                            className="img-fluid"
                            src={getImage(serviceImage.logoView)}
                            alt="img"
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Explore;
